import { z } from "zod";

export const BillingItemSchema = z.object({
  display_name: z.string().min(5, "Too short!, must be greater than 5 characters."),
  description: z.string().optional(),
  billing_rate: z.union([z.literal("variable"), z.number()]),
  service_fee_exempt: z.boolean(),
});

export const BillingItemsSchema = z
  .object({
    $schema: z.string().optional(),
  })
  .catchall(BillingItemSchema)
  .default({
    lodging: {
      display_name: "Lodging",
      description: "Cost of lodging for travel jobs",
      billing_rate: "variable",
      service_fee_exempt: true,
    },
    fork_lift: {
      display_name: "Late Scheduling Fee",
      description: "Fee applied for scheduling requests made with less than 2 business day notice of the start date.",
      billing_rate: 25.0,
      service_fee_exempt: false,
    },
    stage_hand: {
      display_name: "Stagehand",
      description: "General labor for events.",
      billing_rate: 50.0,
      service_fee_exempt: false,
    },
  });
